module.exports = __webpack_public_path__ + "img/psd.60d6deb1.png";